import linkedInIcon from "./assets/linkedin.png";
import instagramIcon from "./assets/instagram.png";
import facebookIcon from "./assets/facebook.png";

// Expert Finance's own social accounts - not personal profiles.
// Used by the footer (every page) and the Our Team page.
// Change a URL here and it updates in both places.
export const socialLinks = [
  {
    label: "LinkedIn",
    icon: linkedInIcon,
    href: "https://www.linkedin.com/company/expertfinancenz/posts/?feedView=all",
  },
  {
    label: "Instagram",
    icon: instagramIcon,
    href: "https://www.instagram.com/financesorted4u/",
  },
  {
    label: "Facebook",
    icon: facebookIcon,
    href: "https://www.facebook.com/financesorted4u",
  },
];
